<template>
  <div v-click-outside="onClickOutside" class="product-cart">
    <product-cart-link v-bind="{ title }" />
    <product-cart-popup v-bind="{ checkoutUrl, checkoutText, emptyText, closeText, apiUrl }" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductCartLink from './product-cart-link.vue';
import ProductCartPopup from './product-cart-popup.vue';

export default {
  name: 'product-cart',
  components: {
    [ProductCartLink.name]: ProductCartLink,
    [ProductCartPopup.name]: ProductCartPopup,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
    checkoutUrl: {
      type: String,
      required: true,
    },
    checkoutText: {
      type: String,
      required: true,
    },
    emptyText: {
      type: String,
      required: true,
    },
    closeText: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('cart', ['open']),
  },
  created() {
    this.$store.dispatch('cart/initialize', {
      origin: this.apiUrl,
    });
  },
  methods: {
    onClickOutside(event) {
      if (!this.open) {
        return;
      }

      event.preventDefault();

      this.$store.commit('cart/toggle', false);
    },
  },
};
</script>
